var SharedUser, SupportAPIHelper, SupportAjaxShimTemplate, async, callWasInterrupted;

async = require('../../../../core/frontend/vendor_modules/async');

SharedUser = require('../../../shared/frontend/helpers/user');

SupportAjaxShimTemplate = require('../../ajax_shim.html.mustache');

callWasInterrupted = function(status, errorMessage) {
  return status === 'abort' || (errorMessage == null) || (errorMessage != null ? errorMessage.length : void 0) === 0;
};

SupportAPIHelper = {
  httpErrorHandler: (function(_this) {
    return function(response, status, errorMessage) {
      if (callWasInterrupted(status, errorMessage)) {
        return;
      }
      flash('error', 'Sorry something went wrong');
      return $('#g-spinner').hide();
    };
  })(this),
  errorHandler: function(errorMessage) {
    return flash('error', errorMessage);
  },
  parallel: function(urls, datas, responseCallback, blockUI, timer, timeout, methods) {
    var callbacks, errorCb, requests, successCb;
    if (methods == null) {
      methods = [];
    }
    successCb = function(cb) {
      return (function(_this) {
        return function(response) {
          return cb(null, response);
        };
      })(this);
    };
    errorCb = function(cb) {
      return (function(_this) {
        return function(errorMessage) {
          return cb(null, null);
        };
      })(this);
    };
    requests = [];
    callbacks = [];
    _.each(urls, (function(_this) {
      return function(url, index) {
        return callbacks.push(function(cb) {
          var req;
          if (methods[index] != null) {
            req = _this.call(url, methods[index], datas[index], successCb(cb), errorCb(cb), blockUI, timer, timeout);
          } else {
            req = _this.get(url, datas[index], successCb(cb), errorCb(cb), blockUI, timer, timeout);
          }
          return requests.push(req);
        });
      };
    })(this));
    async.parallel(callbacks, (function(_this) {
      return function(err, results) {
        if (err != null) {
          return responseCallback(null);
        }
        return responseCallback(results);
      };
    })(this));
    return requests;
  },
  get: function(url, data, success, error, blockUI, timer, timeout) {
    var args;
    if (timer == null) {
      timer = null;
    }
    if (timeout == null) {
      timeout = 70000;
    }
    args = Array.prototype.slice.call(arguments);
    switch (args.length) {
      case 2:
        success = data;
        data = void 0;
        break;
      case 3:
        if (typeof args[1] === 'function') {
          error = success;
          success = data;
          data = void 0;
        }
    }
    return this.call(url, 'GET', data, success, error, blockUI, timer, timeout);
  },
  call: function(url, method, data, successHandler, customErrorHandler, blockUI, timer, timeout) {
    var ajaxShimTemplate, options, request;
    if (timer == null) {
      timer = null;
    }
    if (timeout == null) {
      timeout = 70000;
    }
    data || (data = {});
    switch (method) {
      case 'PUT':
        method = 'POST';
        data._method = 'PUT';
        break;
      case 'DELETE':
        method = 'POST';
        data._method = 'DELETE';
    }
    if (blockUI) {
      ajaxShimTemplate = SupportAjaxShimTemplate.render({});
      $('body').append(ajaxShimTemplate);
    }
    options = {
      url: url,
      type: method,
      dataType: 'json',
      headers: {},
      timeout: timeout,
      data: data,
      error: (function(_this) {
        return function(err, status, errorMessage) {
          if (timer != null) {
            stopTimer(timer);
          }
          if (blockUI) {
            $('.ajaxshim').remove();
          }
          if (customErrorHandler) {
            return customErrorHandler(errorMessage);
          } else {
            return _this.httpErrorHandler(err, status, errorMessage);
          }
        };
      })(this),
      success: (function(_this) {
        return function(response) {
          if (timer != null) {
            stopTimer(timer);
          }
          $('.ajaxshim').remove();
          if (!response || response.length === 0 || (response.error != null)) {
            if (customErrorHandler != null) {
              return customErrorHandler(response);
            } else {
              return _this.errorHandler(null);
            }
          } else {
            return successHandler(response);
          }
        };
      })(this)
    };
    SharedUser.setGrpnUsrHeader(options);
    if (timer != null) {
      startTimer(timer);
    }
    request = $.ajax(options);
    return request;
  }
};

module.exports = SupportAPIHelper;

//# sourceMappingURL=data:application/json;base64,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
